import React from "react";
import Header from "../components/layouts/Header";
import Footer from "../components/layouts/Footer";
import TituloRecubrimientoPisos from "../components/sections/RecubrimientosPisos/TituloRecubrimientoPisos";
import CatalogoPisos from "../components/sections/RecubrimientosPisos/CatalogoPisos";
import IntroPisos from "../components/sections/RecubrimientosPisos/IntroPisos";
import FormularioPisos from "../components/sections/RecubrimientosPisos/FormularioPisos";

const RecubrimientosPisos = () => {
    return (
        <div>
            <Header />
            <TituloRecubrimientoPisos />
            <CatalogoPisos />
            <IntroPisos />
            <FormularioPisos />
            <Footer />
        </div>
    );
};

export default RecubrimientosPisos;